// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "includedBaggage__header-2M1ey";
export { _1 as "__esModule", _2 as "includedBaggage__header" }
export default { "__esModule": _1, "includedBaggage__header": _2 }
